import { arrayOf, string } from 'prop-types';

export const DemosType = arrayOf(string);

export default DemosType;
